import React, { useCallback } from 'react'
import api from '../../../../../services/api'
import Form, { Input, Select } from '../../../../../components/Form'
import { useHistory } from 'react-router-dom'
import { useToast } from '../../../../../hooks/toast'
import { useLoading } from '../../../../../hooks/loading'
import { apiCreate, apiUpdate } from '../../domain/api'
import { nameActions } from '../../domain/info'
import { FormContainer } from './styles'

type TypesFormProps = {
  initialValues?: ServicesCountriesApiResponse & {
    idUpdate: number
  }
  typeForm: 'create' | 'update'
}

const toastSuccessData: Record<string, () => ToastMessage> = {
  create: () => ({
    type: 'success',
    title: 'Registro criado',
    description: 'Registro criado com sucesso'
  }),
  update: () => ({
    type: 'success',
    title: 'Registro atualizado',
    description: 'Registro alterado com sucesso'
  })
}

const toastErrorData: Record<string, () => ToastMessage> = {
  create: () => ({
    type: 'error',
    title: 'Erro ao adicionar o registro',
    description:
      'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
  }),
  update: () => ({
    type: 'error',
    title: 'Erro ao atualizar',
    description:
      'Ocorreu um erro ao alterar os dados, por favor, tente novamente.'
  })
}

export const FormServicesCountries = ({
  initialValues,
  typeForm
}: TypesFormProps): JSX.Element => {
  const { addToast } = useToast()
  const history = useHistory()
  const { activeLoading, disableLoading } = useLoading()

  const onSubmitForm = useCallback(
    async (data: any) => {
      const id = initialValues?.idUpdate
      const payload =
        typeForm === 'create'
          ? { name: data.name }
          : { name: data.name, active: data.active }
      const apiRequest =
        typeForm === 'create'
          ? api.post(apiCreate(), payload)
          : api.put(apiUpdate(id.toString()), payload)

      try {
        activeLoading()
        await apiRequest
        addToast(toastSuccessData[typeForm]?.())
        history.push(nameActions.read.to)
      } catch (error) {
        addToast(toastErrorData[typeForm]?.())
      } finally {
        disableLoading()
      }
    },
    [
      activeLoading,
      addToast,
      disableLoading,
      history,
      initialValues?.idUpdate,
      typeForm
    ]
  )

  return (
    <Form
      onSubmit={onSubmitForm}
      defaultValues={{
        name: initialValues?.name,
        ...(typeForm === 'update' && {
          active: Number(initialValues?.active)
        })
      }}
    >
      <>
        <div className="card">
          <FormContainer>
            <div className="row mb-5">
              <Input
                name="name"
                label="Nome"
                rules={{ required: true, maxLength: 100 }}
                className="col-md-4"
              />
              {typeForm === 'update' && (
                <Select
                  className="col-md-2"
                  name="active"
                  label="Ativo"
                  options={[
                    {
                      name: 'Sim',
                      value: 1
                    },
                    {
                      name: 'Não',
                      value: 0
                    }
                  ]}
                  rules={{ required: true }}
                  blank
                />
              )}
            </div>
          </FormContainer>
          <div className="card-footer d-flex justify-content-end py-6 px-9">
            <button type="submit" className="btn btn-primary">
              Salvar
            </button>
          </div>
        </div>
      </>
    </Form>
  )
}
